var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4,5.2v0Zm0,.5h.2v-1H2.4Zm.2,0a.9.9,0,0,1,.9.9h1A1.9,1.9,0,0,0,2.6,4.7Zm.9.9v7h1v-7Zm0,7a.9.9,0,0,1-.9.9v1a1.9,1.9,0,0,0,1.9-1.9Zm-.9.9H2.4v1h.2Zm-.2,0a.9.9,0,0,1-.9-.9H.5a1.9,1.9,0,0,0,1.9,1.9Zm-.9-.9v-7H.5v7Zm0-7a.9.9,0,0,1,.9-.9v-1A1.9,1.9,0,0,0,.5,6.6ZM8,1.5a.9.9,0,0,1,.9.9h1A1.9,1.9,0,0,0,8,.5Zm.9.9V13.6h1V2.4Zm0,11.2a.9.9,0,0,1-.9.9v1a1.9,1.9,0,0,0,1.9-1.9Zm-.9.9a.9.9,0,0,1-.9-.9h-1A1.9,1.9,0,0,0,8,15.5Zm-.9-.9V2.4h-1V13.6Zm0-11.2A.9.9,0,0,1,8,1.5V.5A1.9,1.9,0,0,0,6.1,2.4Zm6.5,7.1a.9.9,0,0,1,.9.9h1a1.9,1.9,0,0,0-1.9-1.9Zm.9.9v3.2h1V10.4Zm0,3.2a.9.9,0,0,1-.9.9v1a1.9,1.9,0,0,0,1.9-1.9Zm-.9.9a.9.9,0,0,1-.9-.9h-1a1.9,1.9,0,0,0,1.9,1.9Zm-.9-.9V10.4h-1v3.2Zm0-3.2a.9.9,0,0,1,.9-.9v-1a1.9,1.9,0,0,0-1.9,1.9Z",
    transform: "translate(-0.5 -0.5)",
    fill: "#15bd8c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.478add172f19d44db3815b56c4253b8f.svg";
export { ForwardRef as ReactComponent };